import { accountsAPI, ProjectType, usersAPI } from './../../../api/projects-api';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AccountType } from './../accounts-reducer';
import { UserType } from './../../Users/users-reducer';
import { setAppErrorAC, setAppStatusAC } from '../../../app/app-reducer';
import { AppRootState } from '../../../app/store';
import { handleRequestResponseError, handleServerNetworkError } from '../../../utils/errorUtils/handleServerNetworkError';


const initialState: NewAccountType = {
  account: {
    id: 0,
    name: '',
    email: '',
    description: '',
    isTrial: false,
    isActive: false,
    //setActive: new Date(),
    users: [] as Array<UserType>,
    rowVersion: ''
  } as AccountType,
  isNotSavedChanges: false
}

export const createNewAccountTC = createAsyncThunk('accounts/createNew', async (params: {account: AccountType}, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  const state = thunkAPI.getState() as AppRootState
  const token = state.auth.token
  let users:Array<UserType> = params.account.users
  try {
    let users:Array<UserType> = params.account.users
    console.log('PARAMS.ACCOUNT', params.account)
    console.log('PARAMS.ACCOUNT', users)
    params.account.users = []
    const res = await accountsAPI.createAccount(token, params.account)
    console.log('ACCOUNT CREATE RES', res.data)
    const id: number = res.data
    let newUsers = users.map(u => {return {...u, accountId: id}})
    console.log('USERS', newUsers)
   for (let i = 0; i< newUsers.length; i ++){
     let res2 = await usersAPI.createUser(token, newUsers[i])
     console.log('res2: ', res2)
   }
    thunkAPI.dispatch(cleanNewAccount())
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
    thunkAPI.dispatch(setAppErrorAC({error: `New Account ${params.account.name} was created!`, color:'success'}))
  } catch (error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue({ errors: [error.message], fieldsErrors: '' })
  }
})

export const createNewUserForNewAccountTC = createAsyncThunk('accounts/createNewUSER', async (params: { user: UserType }, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  try {
    const state = thunkAPI.getState() as AppRootState
    const projects: Array<ProjectType> = state.projects
    let projectsFullInfo: Array<ProjectType> = []
    let projectsOfNewUsers: Array<string> = params.user.projects
    projectsOfNewUsers.forEach(pr => {
      let proj = projects.find(proj => proj.projectName === pr)
      if (proj) {
        projectsFullInfo.push(proj)
      }
    })
    params.user.projects = projectsFullInfo
    thunkAPI.dispatch(createNewUserForNewAccount({user: params.user}))
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
  } catch (error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue({ errors: [error.message], fieldsErrors: '' })
  }
})

const slice = createSlice({
  name: 'newAccount',
  initialState: initialState as NewAccountType,
  reducers: {
    createNewUserForNewAccount(state, action: PayloadAction<{user: UserType}>){
      state.account.users.push(action.payload.user)
      state.isNotSavedChanges = true
    },
    setNewAccountName(state, action: PayloadAction<string>) {
      state.account.name = action.payload
      if(state.account.name !== '' || state.account.email !== '' || state.account.description !== ''){
        state.isNotSavedChanges = true
      } else {
        state.isNotSavedChanges = false
      }
    },
    setNewAccountEmail(state, action: PayloadAction<string>) {
      state.account.email = action.payload
      if(state.account.name !== '' || state.account.email !== '' || state.account.description !== ''){
        state.isNotSavedChanges = true
      } else {
        state.isNotSavedChanges = false
      }
    },
    setNewAccountDescription(state, action: PayloadAction<string>) {
      state.account.description = action.payload
      if(state.account.name !== '' || state.account.email !== '' || state.account.description !== ''){
        state.isNotSavedChanges = true
      } else {
        state.isNotSavedChanges = false
      }
    },
    setNewAccountStatus(state, action: PayloadAction<boolean>) {
      state.account.isActive = action.payload
    },
    cleanNewAccount(state, action: PayloadAction) {
      state.account.name = ''
      state.account.email = ''
      state.account.description = ''
      state.account.isActive = false
      state.account.users = [] as Array<UserType>
      state.isNotSavedChanges = false
    }
  }
})

export const newAccountReducer = slice.reducer
export const {createNewUserForNewAccount, setNewAccountName, setNewAccountEmail, setNewAccountDescription, setNewAccountStatus, cleanNewAccount} = slice.actions

export type NewAccountType = {
  account: AccountType
  isNotSavedChanges: boolean
}
